import { render } from "./LuxuryTravel06.vue?vue&type=template&id=50cd8c82&scoped=true"
import script from "./LuxuryTravel06.vue?vue&type=script&lang=js"
export * from "./LuxuryTravel06.vue?vue&type=script&lang=js"

import "./LuxuryTravel06.scss?vue&type=style&index=0&id=50cd8c82&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50cd8c82"]])

export default __exports__